import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { selectAllIgniteProducts, getIgniteProducts } from '../../reducers/catalog';
import Product from "./Product";
import { useParams, useSearchParams } from "react-router-dom";
import ProductMenu from '../ProductMenu';
import { selectAllMenuItems } from '../../reducers/menu';
import MSMPagination from '../MSMPagination';
import { Container, Row } from "react-bootstrap";
import { getSubsite } from '../../reducers/auth';
const apiUrl = process.env.REACT_APP_LOCALHOST_URL;

const AdminIgniteProducts = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const dispatch = useDispatch();
    const catalog = useSelector(selectAllIgniteProducts);
    const menu = useSelector(selectAllMenuItems);
    const featured = useSelector(state => state.featured);

    const [resetPagination, setResetPagination] = useState(false);
    const [range, setRange] = useState([1, 12]);

    const catalogStatus = useSelector(state => state.catalog.status)
    const currentSubsite = useSelector(getSubsite);

    useEffect(() => {
        if (catalogStatus === 'idle') {
            dispatch(getIgniteProducts());
        }
    }, [catalogStatus, dispatch]);

    const reloadData = (range) => {
        dispatch(getIgniteProducts());
    }
console.log("CATALOG", catalog);
    return (
        <div className="container">
            {catalogStatus === 'loading' && <Spinner text="Loading..." />}
            {catalogStatus === 'error' && <div>Error Loading Ignite Products</div>}
            <Container>
                <Row>
                {catalog && catalog.map(catalogItem => (
                        <Product product={catalogItem} baseUrl={apiUrl} url="../admin/allproduct/details/" />
                    ))}
                </Row>
            </Container>
        </div>
    );
};
export default AdminIgniteProducts;